const mutations = {
  setTimezones(state, timezonesArray) {
    state.timezonesGlobal = timezonesArray
  },
  changePaymentFailedStatus(state, paymentFailedStatus) {
    state.paymentFailed = paymentFailedStatus
  },
  setTeams(state, teams) {
    state.teams = teams
  },
  updateOneTeam(state, newTeam) {
    const teamIndex = state.teams.findIndex(oldTeam => oldTeam.teamId == newTeam.teamId)
    state.teams[teamIndex] = newTeam
  },
  setTeamRole(state, teamRole) {
    state.teamRole = teamRole
  },
  setSelectedTeam(state, index) {
    state.selectedTeam = index
  },
  setTeamMembers(state, members) {
    state.selectedTeamMembers = members
  },
  setCountries(state, list) {
    state.countries = list
  },
  setCreatedTeamId(state, teamId) {
    state.createdTeamId = teamId
  },
  setStripeScriptLoaded(state, loaded) {
    state.stripeScriptLoaded = loaded
  },
  setUserStartOfWeek(state, startDay) {
    state.userStartOfWeek = startDay
  },
  setUserSettings(state, userSett) {
    state.userSettings = userSett
  },
  setOneUserSetting(state, payload) {
    state.userSettings[payload.name] = payload.value
  },

  addWeekToBufferedTeamsSchedules(state, payload) {
    state.bufferedTeamsSchedules[payload.key] = payload.value
  },
  updateLookUpOfBufferedTeamsSchedules(state, payload) {
    state.bufferedTeamsSchedules[payload.key].lastLookUp = payload.timestamp
  },
  limitBufferedTeamsSchedules(state) {
    if (Object.keys(state.bufferedTeamsSchedules).length > 10 * (state.teams.length + 1)) {
      let minTimestamp = new Date().getTime()
      for (const key in state.bufferedTeamsSchedules) {
        minTimestamp = Math.min(minTimestamp, state.bufferedTeamsSchedules[key].lastLookUp)
      }
      for (const key in state.bufferedTeamsSchedules) {
        if (state.bufferedTeamsSchedules[key].lastLookUp == minTimestamp) {
          delete state.bufferedTeamsSchedules[key]
          return
        }
      }
    }
  },

  addWeekToBufferedUsersSchedules(state, payload) {
    state.bufferedUsersSchedules[payload.key] = payload.value
  },
  deleteWeekFromBufferedUsersSchedules(state, key) {
    delete state.bufferedUsersSchedules[key]
  },
  updateLookUpOfBufferedUsersSchedules(state, payload) {
    state.bufferedUsersSchedules[payload.key].lastLookUp = payload.timestamp
  },
  limitBufferedUsersSchedules(state) {
    if (Object.keys(state.bufferedUsersSchedules).length > 30) {
      let minTimestamp = new Date().getTime()
      for (const key in state.bufferedUsersSchedules) {
        minTimestamp = Math.min(minTimestamp, state.bufferedUsersSchedules[key].lastLookUp)
      }
      for (const key in state.bufferedUsersSchedules) {
        if (state.bufferedUsersSchedules[key].lastLookUp == minTimestamp) {
          delete state.bufferedUsersSchedules[key]
          return
        }
      }
    }
  },

  updateBufferedTeamsNotifications(state, payload) {
    state.bufferedTeamsNotifications[payload.key] = payload.value
  },

  updateBufferedTeamsOverdueStatus(state, payload) {
    state.bufferedTeamsOverdueStatus[payload.key] = payload.value
  },

  setPreventScheduleLeave(state, payload) {
    state.preventScheduleLeave = payload
  },
  setPLeaveFlag(state, payload) {
    state.pLeaveFlag = payload
  },
  setShowProgressBar(state, payload) {
    state.showProgressBar = payload
  },

  setHolidayInfo(state, payload) {
    state.holidayInfo[payload.key] = payload.value
  },
  updateHolidayInfo(state, { userId, teamId, year, limit }) {
    let teamHolidayInfo = state.holidayInfo[userId].holidayInfo.find(team => team.teamId == teamId)
    teamHolidayInfo.holiday[year].limit = parseInt(limit)
  },
  limitHolidayInfo(state) {
    if (Object.keys(state.holidayInfo).length > 50) {
      let minTimestamp = new Date().getTime()
      for (const key in state.holidayInfo) {
        minTimestamp = Math.min(minTimestamp, state.holidayInfo[key].lastLookUp)
      }
      for (const key in state.holidayInfo) {
        if (state.holidayInfo[key].lastLookUp == minTimestamp) {
          delete state.holidayInfo[key]
          return
        }
      }
    }
  },

  setFollowedList(state, payload) {
    state.followedList[payload.key] = payload.value
  },
  limitFollowedList(state) {
    if (Object.keys(state.followedList).length > 50) {
      let minTimestamp = new Date().getTime()
      for (const key in state.followedList) {
        minTimestamp = Math.min(minTimestamp, state.followedList[key].lastLookUp)
      }
      for (const key in state.followedList) {
        if (state.followedList[key].lastLookUp == minTimestamp) {
          delete state.followedList[key]
          return
        }
      }
    }
  },

  setCopiedEntry(state, payload) {
    state.copiedEntry = payload
  },

  setIsNotificationsPanelOpen(state, payload) {
    state.isNotificationsPanelOpen = payload
  },

  setShowListOfLateTeamMembers(state, payload) {
    state.showListOfLateTeamMembers = payload
  },

  setTempTimeOffChangesForOneTeam(state, payload) {
    let toUpdate = { ...state.tempTimeOffChanges }
    toUpdate[payload.teamId] = payload.value
    state.tempTimeOffChanges = toUpdate
  },

  clearTempTimeOffChanges(state) {
    state.tempTimeOffChanges = {}
  },

  setIsMonthMode(state, value) {
    state.isMonthMode = value
  },

  addTeamIdToTeamsNotToAskAboutLeaveDays(state, teamId) {
    state.teamsNotToAskAboutLeaveDays.push(teamId)
  },

  clearStore(state) {
    var bTSProps = Object.getOwnPropertyNames(state.bufferedTeamsSchedules)
    for (let i = 0; i < bTSProps.length; i++) {
      delete state.bufferedTeamsSchedules[bTSProps[i]]
    }

    var bUSProps = Object.getOwnPropertyNames(state.bufferedUsersSchedules)
    for (let i = 0; i < bUSProps.length; i++) {
      delete state.bufferedUsersSchedules[bUSProps[i]]
    }

    var bTNProps = Object.getOwnPropertyNames(state.bufferedTeamsNotifications)
    for (let i = 0; i < bTNProps.length; i++) {
      delete state.bufferedTeamsNotifications[bTNProps[i]]
    }
    
    var bTOSProps = Object.getOwnPropertyNames(state.bufferedTeamsOverdueStatus)
    for (let i = 0; i < bTOSProps.length; i++) {
      delete state.bufferedTeamsOverdueStatus[bTOSProps[i]]
    }

    state.createdTeamId = undefined

    var fLProps = Object.getOwnPropertyNames(state.followedList)
    for (let i = 0; i < fLProps.length; i++) {
      delete state.followedList[fLProps[i]]
    }

    var hIProps = Object.getOwnPropertyNames(state.holidayInfo)
    for (let i = 0; i < hIProps.length; i++) {
      delete state.holidayInfo[hIProps[i]]
    }

    var sTProps = Object.getOwnPropertyNames(state.selectedTeam)
    for (let i = 0; i < sTProps.length; i++) {
      delete state.selectedTeam[sTProps[i]]
    }

    state.selectedTeamMembers.length = 0

    state.teamRole = ''

    state.teams.length = 0

    state.stripeScriptLoaded = false

    var uSProps = Object.getOwnPropertyNames(state.userSettings)
    for (let i = 0; i < uSProps.length; i++) {
      delete state.userSettings[uSProps[i]]
    }

    state.userStartOfWeek = 'Monday'

    state.showProgressBar = false

    var cEProps = Object.getOwnPropertyNames(state.copiedEntry)
    for (let i = 0; i < cEProps.length; i++) {
      delete state.copiedEntry[cEProps[i]]
    }
    state.isNotificationsPanelOpen = true

    state.isMonthMode = false

    state.teamsNotToAskAboutLeaveDays = []
  },
}

export default mutations
